import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hideModal } from '../../services/modal/actions';
import { reactivateAccount } from '../../services/account/alo/actions';

import ButtonComponent from '../button/ButtonComponent';
import { LoadingComponent } from '../loading/LoadingComponent';

import './AloReactivateAccountModal.scss';

class AloReactivateAccountModal extends React.Component {
    componentDidUpdate(prevProps) {
        if (prevProps.reactivatingAccount && !this.props.reactivatingAccount) {
            this.props.hideModal();
        }
    }

    submit = () => {
        const { accountId, reactivateAccount } = this.props;

        reactivateAccount(accountId);
    };

    render() {
        const { i18n, reactivatingAccount } = this.props;

        return (
            <div className="alo-reactivate-account-modal">
                <div className="header">
                    <p>{i18n.HEADER}</p>
                </div>
                <div className="content">
                    <p>{i18n.TEXT1}</p>
                    <p>{i18n.TEXT2}</p>
                </div>
                <div className={`buttons ${reactivatingAccount ? 'loading' : ''}`}>
                    {reactivatingAccount ? (
                        <LoadingComponent />
                    ) : (
                        <ButtonComponent text={i18n.BUTTON} color="main" onClick={this.submit} />
                    )}
                </div>
            </div>
        );
    }
}

AloReactivateAccountModal.propTypes = {
    accountId: PropTypes.number.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.ALO.MODAL.REACTIVATE_ACOUNT,
        reactivatingAccount: state.account.accountLinkedOffer.reactivatingAccount
    };
};

const mapDispatchToProps = {
    hideModal,
    reactivateAccount
};

export default connect(mapStateToProps, mapDispatchToProps)(AloReactivateAccountModal);



// WEBPACK FOOTER //
// ./src/components/alo/AloReactivateAccountModal.js